import { clsx } from '../../../ds/clsx';
import type { StaffPortalCard } from '../portal-api';
import record from './record.module.css';
import styles from './portal.module.css';

/**
 * Mandantenportal 28 „Regel im Hintergrund": the assistant's routing rule verbatim and the three contact values
 * it depends on (active deal, lifecycle, owned units). Shown while the contact has a portal account.
 */
export function PortalRuleCard({ rule }: { rule: StaffPortalCard['rule'] }) {
  return (
    <section className={record.card} aria-label="Regel im Hintergrund">
      <div className={styles.eyebrow}>Regel im Hintergrund</div>
      <p className={styles.ruleText}>{rule.text}</p>
      <dl className={styles.ruleRows}>
        <div className={clsx(styles.kv, styles.kvSmall)}>
          <dt>Aktiver Deal</dt>
          <dd>{rule.activeDeal}</dd>
        </div>
        <div className={clsx(styles.kv, styles.kvSmall)}>
          <dt>Lifecycle</dt>
          <dd>{rule.lifecycle}</dd>
        </div>
        <div className={clsx(styles.kv, styles.kvSmall)}>
          <dt>Objekte im Eigentum</dt>
          <dd>{rule.ownedUnits}</dd>
        </div>
      </dl>
    </section>
  );
}
